import type { DesignTokens } from "../types/theme";

// Aula brand font: Outfit (loaded in apps/web/index.html), with a robust
// system fallback chain so text stays readable if the webfont is slow/offline.
const WEB_SYSTEM_FONT =
  "'Outfit', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif";

/**
 * Base tokens for Light mode.
 */
export const LIGHT_BASE_TOKENS: DesignTokens = {
  background: "#f7f7f8",
  foreground: "#1a1a22",
  surface: "#ffffff",
  surfaceForeground: "#1a1a22",
  surfaceSecondary: "#f1f1f4",
  surfaceSecondaryForeground: "#1a1a22",
  surfaceTertiary: "#e9e9ee",
  surfaceTertiaryForeground: "#1a1a22",
  overlay: "#ffffff",
  overlayForeground: "#1a1a22",
  muted: "#71717a",
  default: "#f4f4f5",
  defaultForeground: "#1a1a22",
  accent: "#5b4ee5",
  accentForeground: "#ffffff",
  danger: "#f43f5e",
  dangerForeground: "#ffffff",
  warning: "#f59e0b",
  warningForeground: "#1a1a22",
  success: "#22c55e",
  successForeground: "#1a1a22",
  separator: "#d4d4d8",
  glassBackground: "rgba(255, 255, 255, 0.85)",
  glassBorder: "rgba(0, 0, 0, 0.1)",
  glassHighlight: "rgba(0, 0, 0, 0.08)",
  glow0: "rgba(91, 78, 229, 0.12)",
  glow1: "rgba(99, 102, 241, 0.1)",
  glow2: "rgba(56, 189, 248, 0.08)",
  mutedForeground: "#1a1a22",
  patternType: "none",
  patternOpacity: 10,
  surfaceShadow: "rgba(0, 0, 0, 0.1)",
  overlayShadow: "rgba(0, 0, 0, 0.1)",
  fieldShadow: "rgba(0, 0, 0, 0.1)",
  fieldBorder: "rgba(0, 0, 0, 0.1)",
  fieldPlaceholder: "rgba(0, 0, 0, 0.4)",
  fieldBackground: "rgba(0, 0, 0, 0.03)",
  segment: "#ffffff",
  segmentForeground: "#1a1a22",
  link: "#1a1a22",
  focus: "#5b4ee5",
  fieldForeground: "#1a1a22",
  radius: "0.65rem",
  fontNormal: WEB_SYSTEM_FONT,
  fontMedium: WEB_SYSTEM_FONT,
  fontSemiBold: WEB_SYSTEM_FONT,
  fontBold: WEB_SYSTEM_FONT,
  border: "#d4d4d8",
  primary: "#5b4ee5",
  primaryForeground: "#ffffff",
  secondary: "#f4f4f5",
  secondaryForeground: "#1a1a22",
  backdrop: "rgba(0, 0, 0, 0.5)",
};

/**
 * Base tokens for Dark mode.
 */
export const DARK_BASE_TOKENS: DesignTokens = {
  background: "#000000",
  foreground: "#fafafa",
  surface: "#16161c",
  surfaceForeground: "#fafafa",
  surfaceSecondary: "#1d1d25",
  surfaceSecondaryForeground: "#fafafa",
  surfaceTertiary: "#26262f",
  surfaceTertiaryForeground: "#fafafa",
  overlay: "#1a1a22",
  overlayForeground: "#fafafa",
  muted: "#a1a1aa",
  default: "#2a2a33",
  defaultForeground: "#fafafa",
  accent: "#7c6ef2",
  accentForeground: "#ffffff",
  danger: "#e11d48",
  dangerForeground: "#ffffff",
  warning: "#f59e0b",
  warningForeground: "#1a1a22",
  success: "#22c55e",
  successForeground: "#1a1a22",
  separator: "#3a3a44",
  glassBackground: "rgba(10, 10, 10, 0.985)",
  glassBorder: "rgba(255, 255, 255, 0.12)",
  glassHighlight: "rgba(255, 255, 255, 0.25)",
  glow0: "rgba(124, 110, 242, 0.5)",
  glow1: "rgba(99, 102, 241, 0.45)",
  glow2: "rgba(56, 189, 248, 0.35)",
  mutedForeground: "#fafafa",
  patternType: "none",
  patternOpacity: 10,
  surfaceShadow: "rgba(0, 0, 0, 0.1)",
  overlayShadow: "rgba(0, 0, 0, 0.1)",
  fieldShadow: "rgba(0, 0, 0, 0.1)",
  fieldBorder: "rgba(255, 255, 255, 0.1)",
  fieldPlaceholder: "rgba(255, 255, 255, 0.4)",
  fieldBackground: "rgba(255, 255, 255, 0.03)",
  segment: "#33333d",
  segmentForeground: "#fafafa",
  link: "#fafafa",
  focus: "#7c6ef2",
  fieldForeground: "#fafafa",
  radius: "0.65rem",
  fontNormal: WEB_SYSTEM_FONT,
  fontMedium: WEB_SYSTEM_FONT,
  fontSemiBold: WEB_SYSTEM_FONT,
  fontBold: WEB_SYSTEM_FONT,
  border: "#3a3a44",
  primary: "#7c6ef2",
  primaryForeground: "#ffffff",
  secondary: "#2a2a33",
  secondaryForeground: "#fafafa",
  backdrop: "rgba(0, 0, 0, 0.7)",
};
